<template>
  <div class="mt-15">
    <div v-show="!showSuccess">
      <div class="line"></div>
      <h3>به نیوزباکس خوش آمدید.</h3>
      <h4 v-show="activeStep === 0">برای ثبت نام و استفاده از سرویس، لطفا ایمیل خود را وارد کنید.</h4>
      <el-steps :active="activeStep"
      finish-status="success"
      class="mb-15 text-right"
      style="margin-bottom:30px;">
        <el-step :title="$t('insert_email')"></el-step>
        <el-step :title="$t('insert_verification_code')"></el-step>
        <el-step :title="$t('insert_new_password')"></el-step>
      </el-steps>
      <el-alert
        :title="msg"
        type="error"
        v-if="!loading && msg.length > 0"
        :closable="false"
        class="mb-10">
      </el-alert>
      <el-alert
        :title="cooldownMsg"
        type="error"
        v-if="!loading && activeStep === 0 && cooldownMsg.length > 0"
        :closable="false"
        class="mb-10">
      </el-alert>
      <el-form
      :model="sendEmailForm"
      ref="sendEmailForm"
      label-position="top"
      v-show="activeStep === 0"
      :disabled="loading">
        <el-form-item
        prop="email"
        :rules="[{ required: true, message: $t('email_validation'), trigger: 'blur' },
        { type: 'email', message: $t('email_validation'), trigger: ['blur', 'blur'] }]">
          <el-input class="ltr text-right"
          :placeholder="$t('email')"
          v-model="sendEmailForm.email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
          type="primary"
          @click="handleResetPassFormSubmit()"
          :loading="loading"  class="mt-15">
            {{ $t('next_step') }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-form
      :model="verificationCodeForm"
      ref="verificationCodeForm"
      label-position="top"
      v-show="activeStep === 1"
      :disabled="loading">
        <el-form-item
        prop="code"
        :rules="[{ required: true, message: $t('please_enter_verification_code') }]">
          <small>{{ $t('insert_emailed_verification_code') }}</small>
          <el-input
          v-model="verificationCodeForm.code"
          :placeholder="$t('verification_code')" class="tahoma"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
          type="primary"
          @click="handleResetPassFormSubmit()"
          :loading="loading"
          class="mt-15">
            {{ $t('next_step') }}
          </el-button>
          <el-button
          @click="activeStep = 0"
          :loading="loading"
          class="mt-15">
            {{ $t('prev_step') }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-form
      :model="userForm"
      status-icon
      ref="userForm"
      label-position="top"
      :rules="rules"
      v-show="activeStep === 2"
      :disabled="loading">
        <el-form-item prop="name">
          <el-input type="name"
          v-model="userForm.name"
          :placeholder="$t('name')"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password"
          v-model="userForm.password"
          :placeholder="$t('password')"></el-input>
        </el-form-item>
        <el-form-item prop="confirm_password">
          <el-input type="password"
          v-model="userForm.confirm_password"
          :placeholder="$t('password')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
          type="primary"
          @click="handleResetPassFormSubmit()"
          :loading="loading"
          class="mt-15">
            {{ $t('submit') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <transition name="el-zoom-in-top">
      <div v-show="showSuccess" class="text-center">
        <h4 class="text-center no-margin">
          {{ $t('registration_successful') }}
        </h4>
        <div class="line"></div>
        <a :href="loginLink">
          {{ $t('login_to_newsbox') }}
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import { password as passwordPattern } from '@/utils/patterns'
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    const checkNewPassword = (rule, value, callback) => {
      if (!passwordPattern.test(value)) {
        callback(new Error(this
          .$i18n.t('password_validator')))
      } else {
        callback()
      }
    }
    const checkConfirmNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('please_insert_password_confirmation')))
      } else if (value !== this.userForm.password) {
        callback(new Error(this.$i18n.t('passwords_do_not_match')))
      } else {
        callback()
      }
    }
    return {
      msg: '',
      showSuccess: false,
      activeStep: 0,
      loading: false,
      domain: null,
      verificationID: null,
      anonymousUserID: null,
      cooldownMsg: '',
      loginForm: {
        client_id: process.env.VUE_APP_USER_CLIENT_ID,
        client_secret: process.env.VUE_APP_USER_CLIENT_SECRET,
        grant_type: 'client_credentials'
      },
      sendEmailForm: {
        email: ''
      },
      verificationCodeForm: {
        code: ''
      },
      userForm: {
        name: '',
        password: '',
        confirm_password: ''
      },
      forgotPassVisible: false,
      rules: {
        name: [
          { required: true, message: this.$i18n.t('field_required'), trigger: 'blur' }
        ],
        password: [
          { validator: checkNewPassword, trigger: 'blur' }
        ],
        confirm_password: [
          { validator: checkConfirmNewPassword, trigger: 'blur' }
        ]
      },
      forms: ['sendEmailForm', 'verificationCodeForm', 'userForm'],
      callbacks: [this.handleSendEmail, this.handleCheckVerificationCode, this.handlePasswordChange]
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    currentForm () {
      return this.forms[this.activeStep]
    },
    currentCallback () {
      return this.callbacks[this.activeStep]
    },
    loginLink () {
      return `https://${process.env.VUE_APP_SERVER_URL}/login`
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    disableLoading () {
      this.loading = false
    },
    handleCreateVerificationSuccess (res) {
      if (res.id) {
        this.verificationID = res.id
        this.activeStep = 1
      }
    },
    createVerificationExistingHandle () {
      this.cooldownMsg = ''
      this.handleRequest({
        name: `${this.domain}/verifications/create-for-existing-handle`,
        action: 'create',
        data: {
          handle: this.sendEmailForm.email
        },
        tokenScope: 'client'
      }).then(res => {
        this.msg = this.$i18n.t('email_already_exists')
        this.disableLoading()
        this.handleCreateVerificationSuccess(res)
      })
        .catch(this.handleCreateVerificationError)
    },
    handleCreateVerificationError (error) {
      const { response } = error
      const { status } = response
      this.cooldownMsg = ''
      this.msg = ''
      if (status === 406) {
        this.createVerificationExistingHandle()
      }
      if (status === 423) {
        this.cooldownMsg = this.$i18n.t('can_not_send_verification_code_under_n_minutes')
      }
    },
    createVerificationForMissingHandle () {
      this.cooldownMsg = ''
      this.handleRequest({
        name: `${this.domain}/verifications/create-for-missing-handle`,
        action: 'create',
        data: {
          handle: this.sendEmailForm.email
        },
        tokenScope: 'client'
      }).then(this.handleCreateVerificationSuccess)
        .catch(this.handleCreateVerificationError)
    },
    handleRequests () {
      this.handleRequest({
        name: 'self',
        action: 'getAll',
        tokenScope: 'client'
      })
        .then(res => {
          const { domain } = res
          this.domain = `domains/${domain.id.numberStr}`
          this.createVerificationForMissingHandle()
        })
        .finally(this.disableLoading)
    },
    handleSendEmail () {
      let formData = new FormData()
      let { loginForm } = this
      for (const prop in loginForm) {
        formData.append(prop, loginForm[prop])
      }
      this.handleRequest({
        name: 'auth/token',
        action: 'create',
        data: formData
      }).then(res => {
        if (res) {
          window.localStorage.setItem('client_access_token', res.access_token)
          window.localStorage.setItem('token_type', res.token_type)
          this.handleRequests()
        }
      }).catch(this.disableLoading)
    },
    handleCheckVerificationCode () {
      this.msg = ''
      if (this.verificationID !== null) {
        this.handleRequest({
          name: `${this.domain}/anonymous-users`,
          action: 'create',
          data: {
            verification_id: this.verificationID,
            handle: this.sendEmailForm.email,
            code: this.verificationCodeForm.code
          },
          tokenScope: 'client'
        }).then(res => {
          if (res.id) {
            this.anonymousUserID = res.id
            this.activeStep = 2
          }
        }).catch(this.disableLoading)
      }
    },
    handlePasswordChange () {
      const toPatch = [{
        op: 'set',
        path: 'user.name',
        value: this.userForm.name
      },
      {
        op: 'set',
        path: 'user.password',
        value: this.userForm.password
      },
      {
        op: 'set',
        path: 'create_team',
        value: true
      }]
      this.handleRequest({
        name: `${this.domain}/anonymous-users`,
        action: 'patch',
        data: {
          id: this.anonymousUserID,
          toPatch
        },
        tokenScope: 'client'
      }).then(res => {
        this.showSuccess = true
      }).catch(this.disableLoading)
    },
    handleResetPassFormSubmit () {
      let { currentForm, currentCallback } = this
      this.$refs[currentForm].validate((valid) => {
        if (valid) {
          this.loading = true
          currentCallback()
        } else {
          return false
        }
      })
    },
    resetForm (currentForm) {
      this.$refs[currentForm].resetFields()
      this.$refs[currentForm].clearValidate()
    },
    handleKeyPress (e) {
      let { key } = e
      if (key === 'Enter') {
        e.preventDefault()
        this.handleResetPassFormSubmit()
      }
    }
  },
  watch: {
    activeStep () {
      this.loading = false
    }
  },
  created () {
    document.addEventListener('keypress', this.handleKeyPress)
  },
  beforeDestroy () {
    document.removeEventListener('keypress', this.handleKeyPress)
  }
}
</script>
